<template>
  <div class="the-navbar__user-meta flex items-center">
    <div
      v-if="userData && userData.firstName"
      class="text-right leading-tight hidden sm:block items-center mr-3"
    >
      <!-- <h6>{{ userData.firstName }} {{ userData.lastName }}</h6> -->
      <!-- <small>Online</small> -->
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img">
        <!-- <img v-if="userData.profilePictureUrl" key="onlineImg" :src="constants.s3Bucket+'/editor/profile-pictures/'+userData.profilePictureUrl" alt="user-img" width="32" height="32" class="rounded-full shadow-md cursor-pointer block" />
        <img v-else key="onlineImg" src="@/assets/images/icons/gender/default.png" alt="user-img" width="32" height="32" class="rounded-full shadow-md cursor-pointer block" /> -->
        <vs-avatar
          v-if="userData && userData.profilePictureUrl"
          class="m-0"
          size="32px"
          :src="
            constants.s3Bucket +
            '/editor/profile-pictures/' +
            userData.profilePictureUrl
          "
        />
        <vs-avatar
          v-else
          class="m-0"
          size="32px"
          :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
            userData.firstName,
            userData.lastName
          )}`"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 15rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/organization/create').catch(() => {})"
          >
            <!-- <feather-icon icon="WorkIcon" svgClasses="w-4 h-4" /> -->
            <vs-icon icon="business" size="17px" />
            <span class="ml-2">Create Organization</span>
          </li>

          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="configUserDashboard"
          >
            <vs-icon icon="extension" size="17px" />
            <span class="ml-2">Config Dashboard</span>
          </li> -->

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/user/settings').catch(() => {})"
          >
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Settings</span>
          </li>

          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/user/messages').catch(() => {})">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Messages</span>
          </li> -->

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import constants from "@/constants";
// import ConfigDashBoard from "./ConfigDashBoard.vue";

export default {
  data() {
    return {
      constants,
    };
  },
  // components: {
  //   ConfigDashBoard,
  // },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
  },
  methods: {
    logout() {
      //TalentPaint Session Destroy For Alex
      this.$store.dispatch(
        "alex/deleteSession",
        this.$store.state.auth.user._id
      );
      //TalentPaint Session Destroy For Gala Or Journey App
      this.$store.dispatch(
        "boards/deleteSession",
        this.$store.state.auth.user._id
      );
      //Youlab Session Destroy For Gala Or Journey App
      this.$store.dispatch(
        "editor/deleteSession",
        this.$store.state.auth.user._id
      );
      this.$store.dispatch("auth/logout").then(() => {
        window.location.href = "/";
      });
    },
    configUserDashboard() {
      this.$store.commit("dashboard/SET_CONFIG_DASHBOARD", true);
      document.querySelector(".con-img").click();
    },
  },
};
</script>
